import React, { useState } from 'react';
import { Link } from 'react-router-dom';
//import { useCookies } from 'react-cookie';
import { useHistory, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";

function AvailableKingdom(props) {
    //const [cookies] = useCookies(['user']);
	//const user_id = cookies.user_id;
	//const token = cookies.token;
    let history = useHistory();
    const { state } = props.location
	const [availableKingdom] = useState(state[0]);

    const [kdImage, setKdImage] = useState("");
	const [kdName, setKdName] = useState("");
	const [msg, setMsg] = useState("");
	const [redirect,setRedirect] = useState("");

    console.log(availableKingdom);
    const row1 = [];
    const row2 = [];
    const row3 = [];
    const row4 = [];
    const row5 = [];
    const row6 = [];
    const row7 = [];
    const row8 = [];
    let i = 0;
    function setPopUp(params){
        setKdImage(params.kd_image);
        setKdName(params.name);
        setMsg("Check out kingdom "+params.name+". Lets's go to war them.");
	}
	function closeMOdal(availableKingdom){
		setRedirect(<Redirect to={{
			pathname:"/chat",
			state: [availableKingdom,"send",msg]
		}}  />);
	}
    for (const [index, value] of availableKingdom.avail_war_kd.entries()) {
        var card =
            <div className="col-4 col-md-4 col-lg-4 p-0" data-toggle="modal" data-target="#bottom_modal" key={index}  onClick={() => setPopUp(value)} >
                <div className="kingdom-pic" style={{backgroundImage: `url(${value.kd_image})`}}></div>
                <h3 className="text-center mt-2">Kingdom <br></br>{value.name}</h3>
            </div>; 
        if(availableKingdom.is_leader === 1){
            card = <Link to={{
                    pathname:"/war-zone",
                    state: [value, availableKingdom]
                }} className="col-4 col-md-4 col-lg-4 p-0" key={index}>
                    <div className="kingdom-pic" style={{backgroundImage: `url(${value.kd_image})`}}></div>
                    <h3 className="text-center mt-2">Kingdom <br></br>{value.name}</h3>
                </Link>; 
        }
        if(i <= 2){
            row1.push(card);
        }else if(i <=5){
            row2.push(card);
        }else if(i <=8){
            row3.push(card);
        }else if(i <=11){
            row4.push(card);
        }else if(i <=14){
            row5.push(card);
        }else if(i <=17){
            row6.push(card);
        }else if(i <=20){
            row7.push(card);
        } else {
            row8.push(card);
        }
        i++;
    }
    return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": 'css/availabel-kingdoms.css'}]
	}/>
    <div className="row no-gutters">
      <div className="application bg-grey">
          {/* <div style = {{
              backgroundImage: `linear-gradient(#1A3163, #6D6264) , url(${availableKingdom.kd_image}) `,
              backgroundBlendMode: `multiply`,
              backgroundPosition: `initial`,
              height:`84px`,
              backgroundRepeat: `no-repeat`,
              backgroundSize: `100% 100%`,
              borderBottomLeftRadius: `8px`,
              borderBottomRightRadius: `8px`,
				}}
            > */}
            <div className="bg-gradient1">
            <div className="appHeader bg-transparent text-light position-relative">
            <div className="left">
                <a className="headerButton goBack" onClick={() => history.goBack()} >
                    <img src={require("./../images/back.png").default} alt="back"  className="img-fluid" />
                </a>
            </div>
            <div className="pageTitle">Kingdom {availableKingdom.kd_name}</div>
            <div className="right">
                <div className="headerButton">
                <Link to="/faq">
                    <img src={require("./../images/faq.png").default} alt="faq" className="img-fluid" />
                </Link>
                </div>
            </div>
            </div>
        </div>
     
        <div className="section kingdom-availabel">
            <div className="row mx-auto">
                <p>Kingdoms availabel for war</p>
            </div>
            <div className="kingdom-war">
                <div className="row mx-auto p-0 mt-3">
                    {row1}
                </div>
                <div className="row mx-auto p-0 mt-3">
                    {row2}
                </div>
                <div className="row mx-auto p-0 mt-3">
                    {row3}
                </div>
                <div className="row mx-auto p-0 mt-3">
                    {row4}
                </div>
                <div className="row mx-auto p-0 mt-3">
                    {row5}
                </div>
                <div className="row mx-auto p-0 mt-3">
                    {row6}
                </div>
                <div className="row mx-auto p-0 mt-3">
                    {row7}
                </div>
                <div className="row mx-auto p-0 mt-3">
                    {row8}
                </div>
                
            </div>
            
        </div>
      </div>

    <div className="modal bottom fade" id="bottom_modal" tabIndex="-1" role="dialog" aria-labelledby="bottom_modal">
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header border-0 px-26 text-center d-block" style={{height: `50px`}}>
                    <h5 className="modal-title">Share this kingdom</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{opacity: `1`,position: `relative`,top: `-20px`}}>
                        <img src={require("./../images/close.png").default} alt="close" className="img-fluid" />
                    </button>
                </div>
                <div className="modal-body px-34">
                    <img src={kdImage} alt="image" className="imaged w69 rounded"/>
                    <p className="mb-0 text-black">Kingdom {kdName}</p>
                    <p className="mb-0 desc">Only King can declare a war against another <br /> Kingdom.</p>
                    <div className="row justify-content-center my-3">
                        <div className="col-8 col-md-8 col-lg-8" >
                            <a className="btn btn-apply btn-block" onClick={() =>closeMOdal(availableKingdom)}  data-dismiss="modal" aria-label="Close" >
                                Share in group chat
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {redirect}

    <div className="bg"></div>
    </div>
</>
    );
}

export default AvailableKingdom;
